<template>
  <div>
    <b-row>
      <b-col>
        <label>Namn:</label>
        <b-input v-model="place.Name" v-bind:readonly="readonly" placeholder="Namn"></b-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label>Adress:</label>        
        <b-input v-model="place.Street" v-bind:readonly="readonly" placeholder="Gatuadress"></b-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-input v-model="place.Street2" v-bind:readonly="readonly" placeholder="Gatuadress - rad2"></b-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="2">
        <b-input v-model="place.CountryCode" v-bind:readonly="readonly" placeholder="Landskod"></b-input>
      </b-col>
      <b-col cols="3">
        <b-input v-model="place.PostCode" v-bind:readonly="readonly" min="10000" max="99999" placeholder="Postnr"></b-input>
      </b-col>
      <b-col cols="7">
        <b-input v-model="place.City" v-bind:readonly="readonly" placeholder="Ort"></b-input>
      </b-col>
    </b-row>
    <!-- <b-row>
      <b-col>
        <label>Kontaktnamn:</label>
        <b-input v-model="place.ContactName" v-bind:readonly="readonly" placeholder="Kontakt (namn)"></b-input>
      </b-col>
    </b-row> -->
    <b-row>
      <b-col>
        <label>Mobiltelefon:</label>
        <b-input v-model="place.ContactPhone" v-bind:readonly="readonly" placeholder="Mobiltelefon"></b-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label>Epost:</label>
        <b-input v-model="place.ContactEmail" v-bind:readonly="readonly" placeholder="Epost"></b-input>
      </b-col>
    </b-row>
    <!-- <b-row>
      <b-col>
        <label>Notering:</label>
        <b-input v-model="place.ContactNote" v-bind:readonly="readonly" placeholder="Notering"></b-input>
      </b-col>
    </b-row> -->
  </div>
</template>
<script>
export default {
  name: "placeedit",
  props: { place: Object, readonly: Boolean },
  data() {
    return {
      id: 0
    };
  },
  methods: {
    GetPlaceJson: () => {
      return JSON.stringify(this.place);
    }
  }
};
</script>
